import type * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AdminSchoolContentLocksQueryVariables = Types.Exact<{
  schoolId: Types.Scalars['ID']['input'];
}>;


export type AdminSchoolContentLocksQuery = { __typename?: 'RootQueryType', contentLocks: Array<{ __typename?: 'ContentLock', id: string, sourceId: string, lockType: string }> };


export const AdminSchoolContentLocksDocument = gql`
    query AdminSchoolContentLocks($schoolId: ID!) {
  contentLocks(schoolId: $schoolId) {
    id
    sourceId
    lockType
  }
}
    `;

/**
 * __useAdminSchoolContentLocksQuery__
 *
 * To run a query within a React component, call `useAdminSchoolContentLocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSchoolContentLocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSchoolContentLocksQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useAdminSchoolContentLocksQuery(baseOptions: Apollo.QueryHookOptions<AdminSchoolContentLocksQuery, AdminSchoolContentLocksQueryVariables> & ({ variables: AdminSchoolContentLocksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminSchoolContentLocksQuery, AdminSchoolContentLocksQueryVariables>(AdminSchoolContentLocksDocument, options);
      }
export function useAdminSchoolContentLocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminSchoolContentLocksQuery, AdminSchoolContentLocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminSchoolContentLocksQuery, AdminSchoolContentLocksQueryVariables>(AdminSchoolContentLocksDocument, options);
        }
// @ts-ignore
export function useAdminSchoolContentLocksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminSchoolContentLocksQuery, AdminSchoolContentLocksQueryVariables>): Apollo.UseSuspenseQueryResult<AdminSchoolContentLocksQuery, AdminSchoolContentLocksQueryVariables>;
export function useAdminSchoolContentLocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminSchoolContentLocksQuery, AdminSchoolContentLocksQueryVariables>): Apollo.UseSuspenseQueryResult<AdminSchoolContentLocksQuery | undefined, AdminSchoolContentLocksQueryVariables>;
export function useAdminSchoolContentLocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminSchoolContentLocksQuery, AdminSchoolContentLocksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminSchoolContentLocksQuery, AdminSchoolContentLocksQueryVariables>(AdminSchoolContentLocksDocument, options);
        }
export type AdminSchoolContentLocksQueryHookResult = ReturnType<typeof useAdminSchoolContentLocksQuery>;
export type AdminSchoolContentLocksLazyQueryHookResult = ReturnType<typeof useAdminSchoolContentLocksLazyQuery>;
export type AdminSchoolContentLocksSuspenseQueryHookResult = ReturnType<typeof useAdminSchoolContentLocksSuspenseQuery>;
export type AdminSchoolContentLocksQueryResult = Apollo.QueryResult<AdminSchoolContentLocksQuery, AdminSchoolContentLocksQueryVariables>;